import React, { Component } from 'react';
import { styles } from './LogoStyles';
import { css } from 'aphrodite/no-important';

export default class Header extends Component {
  render() {
    return (
      <div className={css(styles.logoWrapper)}>
        <img
          className={css([
            styles.logo,
            this.props.size === 'large' && styles.logoLarge
          ])}
          src={'/icons/logo@2x.png'}
          alt=""
        />
      </div>
    );
  }
}
